var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#1D1D1D;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#D0D0D0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.27,47.94c97.05,10.7,174.07,87.73,184.78,184.78h47.96v46.55h-47.96 c-10.7,97.07-87.73,174.09-184.78,184.8V512h-46.55v-47.93c-97.05-10.7-174.09-87.73-184.8-184.8H-0.01v-46.55h47.93 c10.7-97.05,87.75-174.07,184.8-184.78V0h46.55V47.94z M256,418.91c90.07,0,162.91-72.84,162.91-162.91 c0-90.05-72.84-162.91-162.91-162.91S93.09,165.95,93.09,255.99C93.09,346.06,165.93,418.91,256,418.91z M256,162.9 c51.43,0,93.09,41.66,93.09,93.09c0,51.46-41.66,93.09-93.09,93.09s-93.09-41.64-93.09-93.09C162.91,204.56,204.57,162.9,256,162.9 z M256,302.54c25.59,0,46.55-20.93,46.55-46.55c0-25.59-20.95-46.55-46.55-46.55c-25.61,0-46.55,20.96-46.55,46.55 C209.45,281.61,230.39,302.54,256,302.54z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 256,
    cy: 255.99,
    r: 46.55
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon);
export default __webpack_public_path__ + "static/media/locationicon.74d26956d44137d4509cbb41c3e31693.svg";
export { ForwardRef as ReactComponent };